import { useEffect, useState } from 'react';
import { Tabs, TabsProps } from 'antd';

// services
import NotificationService from 'core/services/notification';
import { onGetSettingCategories } from 'modules/settings/services/settings';
import { onGetAllLanguages } from 'modules/languages/services/languages';

// components
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import SettingsCategoryTabComponent from 'modules/settings/components/settingsCategoryTab/settingsCategoryTab';
import SplashScreenListPage from 'modules/splashScreen/pages/list/list';
import { isRTL } from 'core/services/language';
import { useTranslation } from 'react-i18next';

function ListSettingCategoriesPage() {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);
	const [categoryItems, setCategoryItems] = useState<TabsProps['items']>([
		{
			key: `${0}`,
			label: t('SETTINGS.SPLASH_SCREENS'),
			destroyInactiveTabPane: true,
			children: <SplashScreenListPage />,
		},
	]);

	useEffect(() => {
		getSettingCategory();
	}, []);

	const getSettingCategory = async () => {
		try {
			const languagesResponse = await onGetAllLanguages();

			const langs = languagesResponse.data.data.languages.map((el) => ({ code: el.code, name: el.name }));

			// get categories response
			const categoriesResponse = await onGetSettingCategories();
			const tempItems: TabsProps['items'] = [
				{
					key: `${0}`,
					label: t('SETTINGS.SPLASH_SCREENS'),
					destroyInactiveTabPane: true,
					children: <SplashScreenListPage />,
				},
			];
			categoriesResponse.data.data.setting_categories.forEach((el, index) => {
				tempItems.push({
					key: `${el.id}`,
					label: el.name,
					destroyInactiveTabPane: true,
					children: <SettingsCategoryTabComponent languages={langs} key={el.id} categoryId={el.id} />,
				});
			});
			setCategoryItems(tempItems);

			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.ERROR_OCCURRED'));
		}
	};

	return (
		<>
			<div className="pageHeader">
				<h3>{t('SETTINGS.MANAGEMENT_TITLE')}</h3>
			</div>

			{isLoading ? (
				<LoadingComponent />
			) : (
				<Tabs defaultActiveKey="1" items={categoryItems} size="large" direction={isRTL() ? 'rtl' : 'ltr'} />
			)}
		</>
	);
}

export default ListSettingCategoriesPage;
